<template>
  <section id="Alle-hjemmesider">
    <v-container>
      <div class="all-homepages">
        <div class="all-homepages__title-container mb-5">
          <p class="all-homepages__title-container--title">Hjemmesider</p>
          <div class="all-homepages__title-container--button">
            <department-selector-modal></department-selector-modal>
          </div>
        </div>

        <div class="all-homepages__subtitle mb-5">
          <p class="all-homepages__subtitle">
            {{ cmsConfigHomepages.length }} hjemmesider
          </p>
        </div>

        <div class="all-homepages__card-container">
          <div
            v-for="homepage in cmsConfigHomepages"
            :key="homepage.Dto.HomepageId"
          >
            <v-card
              tile
              elevation="0"
              class="all-homepages__card-container--card mb-5"
              max-width="270"
            >
              <v-img height="160" :src="getImage(homepage)"></v-img>
              <div>
                <p class="all-homepages__card-container--card--title mb-1 mt-5">
                  {{ homepage.Dto.SiteUrl }}
                </p>
                <p
                  class="all-homepages__card-container--card--departments mb-1"
                >
                  {{ homepage.Dto.Sites.length }} av
                  {{ activeDepartments() }} avdelinger online
                </p>
                <div class="">
                  <v-btn
                    outlined
                    rounded
                    hover
                    class="all-homepages__card-container--card--button mb-5"
                    @click="openHomepageEditor(homepage.Dto.HomepageId)"
                  >
                    <span
                      class="all-homepages__card-container--card--button--text"
                      >Rediger</span
                    >
                  </v-btn>
                </div>
              </div>
              <div
                v-if="cmsConfigHomepages.length > 1"
                @click="toggleSettingsMenu(homepage.Dto)"
                class="all-homepages__card-container--card--delete"
              >
                <v-icon
                  class="all-homepages__card-container--card--delete--icon"
                  color="#472449"
                  size="22"
                  >mdi-dots-horizontal</v-icon
                >
              </div>
              <v-slide-x-transition>
                <v-list
                  v-click-outside="closeSettingsMenu"
                  v-if="
                    showHomepageSetting &&
                    selectedHomepage &&
                    homepage.Dto.HomepageId == selectedHomepage.HomepageId
                  "
                  class="all-homepages__card-container--card--delete-menu"
                  :style="
                    $vuetify.breakpoint.smAndDown
                      ? 'right: 0px; top: 55px; width: 100%;'
                      : ''
                  "
                >
                  <v-list-item-group v-model="showHomepageSetting">
                    <v-list-item @click="openDeleteModal()">
                      <v-list-item-icon>
                        <v-icon color="rgba(0, 0, 0, 0.54)" size="22"
                          >mdi-delete</v-icon
                        >
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          class="all-homepages__card-container--card--delete-menu--title"
                          v-text="'Slett hjemmesiden'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-slide-x-transition>
            </v-card>
          </div>

          <v-dialog
            v-model="showDeleteModal"
            max-width="500"
            style="z-index: 9999"
          >
            <v-card>
              <v-card-title
                v-if="selectedHomepage"
                class="all-homepages__card-container--card--delete--icon--dialog-title"
              >
                <v-icon color="#472449" size="32">mdi-alert</v-icon>
                <span
                  class="all-homepages__card-container--card--delete--icon--dialog-title--text"
                  >Er du sikker på at du vil slette
                  {{ selectedHomepage.SiteUrl }}?</span
                >
              </v-card-title>
              <v-card-text
                class="all-homepages__card-container--card--delete--icon--dialog-text"
              >
                Dette sletter hele hjemmesiden med alle undersider, innhold og
                stiler. Du må opprette alle sider på nytt om du gjør dette. Er
                du helt sikker på at du vil slette hjemmesiden permanent? Valget
                kan ikke angres.
              </v-card-text>
              <v-divider class="ma-0"></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="all-homepages__card-container--card--delete--icon--dialog-cancel-btn"
                  text
                  @click="showDeleteModal = false"
                >
                  <span
                    class="all-homepages__card-container--card--delete--icon--dialog-cancel-btn__text"
                    >Avbryt</span
                  >
                </v-btn>
                <v-btn
                  class="all-homepages__card-container--card--delete--icon--dialog-delete-btn"
                  rounded
                  @click="
                    deleteHomepage(
                      selectedHomepage.ChainId,
                      selectedHomepage.HomepageId
                    )
                  "
                >
                  <span
                    class="all-homepages__card-container--card--delete--icon--dialog-delete-btn__text"
                    >Slett hjemmesiden</span
                  >
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
// import { dummyPages } from '../data/dummy'
import DepartmentSelectorModal from "@/components/DepartmentSelectorModal.vue";
export default {
  name: "homepage-selector",
  components: { DepartmentSelectorModal },
  data: () => ({
    pending: false,
    cmsConfig: null,
    showHomepageSetting: false,
    showDeleteModal: false,
    selectedHomepage: null,
  }),
  created() {
    this.$store.dispatch("global/getAllHomepageCmsConfigsByChainId", {
      chainId: window.CONFIG.user.ChainId,
      isDraft: true,
    });
    this.$store.dispatch("global/getNumberOfSitesInChain", {
      chainId: window.CONFIG.user.ChainId,
      isDraft: true,
    });
    this.$store.dispatch("global/getDepartmentsByChainId", {
      chainId: window.CONFIG.user.ChainId,
      isDraft: true,
    });
  },

  computed: {
    cmsConfigHomepages() {
      return this.$store.getters["global/getCmsConfigHomepage"];
    },
    totalSites() {
      return this.$store.getters["global/getDepartmentCount"];
    },
    // pages () {
    //     var cmsConfigHomepages = this.$store.getters['global/getCmsConfigHomepage']
    //     console.log(cmsConfigHomepages)
    //     return this..map(obj => ({
    //         siteUrl: obj.dto.SiteUrl,
    //         numberOfDepartments: obj.dto.sites.length,
    //         imgUrl: obj.dto.chainBanners[0].ImgUrl, //Fetch image from branch/site object instead.
    //         isPublished: obj.dto.CmsEnabled,
    //         chainId: obj.dto.ChainId
    //     }))
    // }
  },
  methods: {
    openHomepageEditor(homepageId) {
      window.location.href =
        "#location=homepageeditor&homepageId=" + homepageId;
    },
    activeDepartments() {
      return this.$store.getters["global/getDepartmentCount"];
    },
    toggleSettingsMenu(homepage) {
      this.showHomepageSetting = !this.showHomepageSetting;
      this.selectedHomepage = homepage;
    },
    closeSettingsMenu() {
      this.showHomepageSetting = !this.showHomepageSetting;
    },
    openDeleteModal(homepage) {
      this.showDeleteModal = !this.showDeleteModal;
    },
    getImage(homepage) {
      //Sjekk alle om det finnes bilde
      let image = homepage.Dto.HomepageBanners.find(
        (el) => el.ImgUrl != undefined && el.ImgUrl != null
      );

      if (
        homepage.Dto.HomepageBanners.length &&
        image != undefined &&
        image != null
      )
        return image.ImgUrl;
      else
        return "https://res.cloudinary.com/odin-systemer-test/image/upload/v1504878944/defaults/d_missing_image_1920x660.png";
      // else return "https://res.cloudinary.com/odin-systemer-test/image/upload/v1400842665/department/manglerbilde.png"
      // else return "https://res.cloudinary.com/odin-systemer-test/image/upload/v1456746740/defaults/d_department.jpg"
      // else return "https://res.cloudinary.com/odin-systemer-test/image/upload/v1459872540/defaults/default_blank.png"
    },
    async deleteHomepage(chainId, homepageId) {
      this.showDeleteModal = false;
      await this.$store.dispatch("global/DeleteHomepageCmsConfig", {
        homepageId: homepageId,
        chainId: chainId,
      });
      await this.$store.dispatch("global/getAllHomepageCmsConfigsByChainId", {
        chainId: window.CONFIG.user.ChainId,
        isDraft: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.all-homepages {
  white-space: nowrap;
  color: #472449;
  &__title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    font-size: 24px;
    &--title {
      margin: 0px;
    }
    &--button {
      margin-right: 5px;
      font-size: 16px;
      padding: 2px 10px;
    }
  }

  &__subtitle {
    font-weight: 700;
    font-size: 16px;
  }
  &__card-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 270px);
    justify-content: space-between;
    grid-gap: 20px;
    position: relative;
    &--card {
      color: #472449;
      text-align: center;
      border: 2px solid;
      border-image: linear-gradient(#bfe5e8, #efddd1) 1;
      &--title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        padding: 0px 16px;
        font-size: 16px;
        font-weight: 700;
      }
      &--published {
        color: #82bcc0;
        font-weight: 700;
        font-size: 14px;
      }
      &--unpublished {
        color: #ea412a;
        font-weight: 700;
        font-size: 14px;
      }
      &--button {
        color: #472449;
        border: 2px solid #472449;
        width: 116px;
        font-weight: 700;
        font-size: 16px;
        text-transform: none;
        line-height: 36px;
        &--text {
          padding-top: 3px;
        }
      }
      &--delete {
        //Hide before hover, and ease into view when hovering
        opacity: 0;
        -webkit-transition: all 250ms ease-in-out;
        -moz-transition: all 250ms ease-in-out;
        -ms-transition: all 250ms ease-in-out;
        -o-transition: all 250ms ease-in-out;
        transition: all 250ms ease-in-out;
        width: 40px;
        height: 40px;
        position: absolute;
        top: 8px;
        right: 8px;
        background: white;
        border: 2px solid #472449;
        border-radius: 50% !important;
        &:hover {
          cursor: pointer;
        }
        &--icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #472449 !important;
          &--dialog-title {
            padding: 16px !important;
            background: linear-gradient(90deg, #bfe5e8 0%, #efddd1 100%);
            color: #472449;
            flex-wrap: nowrap;
            &--text {
              font-weight: 700;
              font-size: 16px;
              line-height: 32px;
              padding-left: 8px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
          &--dialog-text {
            color: #222222;
            padding: 16px !important;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
          }
          &--dialog-cancel-btn {
            &__text {
              color: #472449;
              padding: 0px 5px 0px 5px;
              text-transform: none;
              font-weight: 500;
              font-size: 14px;
              padding-top: 3px;
            }
          }
          &--dialog-delete-btn {
            background-color: #ea412a !important;
            &__text {
              text-transform: none;
              color: white;
              font-weight: 700;
              font-size: 14px;
              padding: 13px 10px 10px 13px;
            }
          }
        }
      }
      &--delete-menu {
        padding: 0px;
        width: 248px;
        position: absolute;
        top: -2px;
        right: -250px;
        z-index: 2;
        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2) !important;
        &--title {
          text-align: left;
          padding-top: 3px;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
}

.all-homepages__card-container--card:hover
  .all-homepages__card-container--card--delete {
  opacity: 1;
}

//Adjust container size when the screen is smaller than 992px wide.
//A scrollbar will appear if the website cards take up more height than the container can fit.
//The scrollbar is hidden for design purposes.
@media (max-width: 992px) {
  .all-homepages {
    width: 80%;
    margin: 0 auto;
    &__card-container {
      justify-content: space-between;
      // overflow-y: auto !important;
    }
  }
  .all-homepages__card-container--card--delete {
    opacity: 1;
  }

  .all-homepages__title-container--button--text {
    display: none;
  }
  .all-homepages__title-container--button--text-small {
    display: initial;
    margin: 0px;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #ffffff;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #ffffff;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(255, 255, 255);
  }
}

//Center the cards when the page is small enough to only show one card per row.
@media (max-width: 770px) {
  .all-homepages__card-container {
    justify-content: center;
  }
}
</style>
